var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getLayoutClass()},[_c(_vm.cWidget.type,{tag:"component",attrs:{"c-conf":_vm.cWidget}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }